/** 本期暂不开放耳机 EQ 配置社区分享；下一期恢复时改为 true */
export const EARPHONE_COMMUNITY_SHARE_ENABLED = false;

export function isEarphoneCommunityShareEnabled(): boolean {
  return EARPHONE_COMMUNITY_SHARE_ENABLED;
}

/** 神光同步 GIF 灯效社区分享 */
export const GIF_LIGHTING_COMMUNITY_SHARE_ENABLED = true;

export function isGifLightingCommunityShareEnabled(): boolean {
  return GIF_LIGHTING_COMMUNITY_SHARE_ENABLED;
}
